import Styles from "./Accuracy.module.scss";
import clsx from "clsx";
import MenuVTC from "../../../Share/Component/MenuVtc";
import Loading from "../../../Share/Component/Loading";
import useClientAccuracy from "../../../Hooks/useClientAccuracy";
import { LoginInput } from "../../../Components/Atoms/LoginInput";
import { Controller } from "react-hook-form";

function Accuracy() {
  const { control, handleSubmit, loading } = useClientAccuracy();

  return (
    <div className={clsx(Styles.main)}>
      {loading ? <Loading /> : null}
      <div className={clsx(Styles.formBox)}>
        <div className={clsx(Styles.formValue)}>
          <h2>Forgot Password</h2>
          <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
            <Controller
              name="userName"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="TÊN TÀI KHOẢN"
                  id="userName"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="EMAIL"
                  id="email"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                  type="email"
                />
              )}
            />
            <button className={clsx(Styles.btnSubmit)} type="submit">
              Xác nhận
            </button>
          </form>
        </div>
      </div>
      <MenuVTC />
    </div>
  );
}
export default Accuracy;
